export const appNameValidate = (value) => {
  if (value === "" || value === undefined || value === null) {
    return "App name is required.";
  } else if (value.length > 50) {
    return "Maximum 50 characters allowed in App name.";
  } else {
    return true;
  }
};

export const redircetUrlValidate = (value) => {
  if (value === "" || value === undefined || value === null) {
    return "Redirect url is required.";
  } else if (value.indexOf("http://") && value.indexOf("https://")) {
    return "Please enter a valid Redirect URL.";
  } else {
    return true;
  }
};

export const validateAppIcon = (value) => {
  const fileSize = value.size / 1024 / 1024;
  let allowedExtension = ["jpeg", "jpg", "png", "svg", "svg+xml"];
  let type = value.type.split("/")[1];

  if (allowedExtension.includes(type) === false) {
    return "Only PNG, JPEG, JPG, SVG image are allowed.";
  } else if (fileSize > 5) {
    return "Image size should be less than 5 MB";
  } else {
    return true;
  }
};
